import {
	booleanAttribute,
	Component,
	forwardRef,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import {
	GenTableComponent,
	GenTablePaginationComponent,
} from "@app/gen-table/gen-table.component"
import { tableNameDisplay } from "@app/helpers"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-gen-table-display",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		forwardRef(() => GenTableComponent),
		BtnExtComponent,
		forwardRef(() => GenTablePaginationComponent),
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./gen-table-display.component.html",
})
export class GenTableDisplayComponent extends Modalable {
	@Input({ transform: booleanAttribute }) emailsAndPhoneValidation: boolean =
		false
	@Input() overrideUpperFields: string[] = []
	@Input() filterField: string = ""
	@Input() filterFieldValue: any = null
	@Input() fieldNameInItemToDisplay: string = ""
	@Input() filterFieldApiObject: any = null
	@Input() filterFieldOrs: any = null
	@Input() tableName: string = ""
	tableNameLang: string = ""
	@Input({ transform: booleanAttribute }) isCheckItems: boolean = false
	@Input({ transform: booleanAttribute }) chooseOnlyOne: boolean = false
	@Input({ transform: booleanAttribute }) updateRow: any = false
	selectedRows: any[] = []
	@Input() objectRow: any = null
	@Input({ transform: booleanAttribute }) isPagi: boolean = false
	isFormSubmittable: boolean = false
	@Input({ transform: booleanAttribute }) ignoreError: boolean = false
	error: string = ""
	editedRow: any = null
	@Input() preChosenItems: any = null // { fieldName: "", values: [] };

	ngOnInit() {
		//when called to open
		if (this.objectRow) {
			this.filterFieldValue = this.objectRow.id
		}
		if (this.tableName) {
			this.tableNameLang = tableNameDisplay(this.tableName)
		}
	}
	validateEmailsAndPhone() {
		if (
			this.selectedRows.find(
				(it) => !["email", "phone"].includes(it.contactway_identifier)
			)
		) {
			this.error = "no_more_than_one_phone"
			this.isFormSubmittable = false
			return
		}
		if (
			this.selectedRows.filter((it) => it.contactway_identifier === "phone")
				.length !== 1
		) {
			this.error = "to_send_password_protected_documents_you_need"
			this.isFormSubmittable = false
			return
		}
		if (!this.selectedRows.find((it) => it.contactway_identifier === "email")) {
			this.error = "to_send_password_protected_documents_you_need"
			this.isFormSubmittable = false
			return
		}
	}
	async checkedItemsChanged(arr: any) {
		await this.store.timeout()
		this.error = ""
		this.selectedRows = [...arr]
		this.isFormSubmittable = !!this.selectedRows.length
		if (!this.isFormSubmittable) {
			this.error = "please_choose_at_least_one"
		}
		if (this.emailsAndPhoneValidation) {
			return this.validateEmailsAndPhone()
		}

		if (this.isCheckItems) {
			for (let row of this.selectedRows) {
				const isValidEmail = this.validator.validateEntireForm(
					row,
					{},
					{ contactway: { email: null } }
				)
				if (!isValidEmail) {
					this.isFormSubmittable = false
					this.error = "invalid_email"
					return
				}
			}
		}
		if (this.chooseOnlyOne) {
			if (this.selectedRows.length != 1) {
				this.error = "phone_or_email_are_required"
				this.isFormSubmittable = false
			}
		}
	}
	rowValidChange(objectCollection: any[]) {
		if (this.updateRow) {
			this.editedRow = objectCollection?.length ? objectCollection[0] : null
		}
	}
	closeWhatsapp() {
		const rows = this.selectedRows.map((row) => ({ ...row, isWhatsapp: true }))
		this.onClose.emit(rows)
	}
}
